<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商户停车卡</el-breadcrumb-item>
      <el-breadcrumb-item>停车卡管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row>
        <el-col :span="4">
          <el-date-picker v-model="queryInfo.queryStartDate" type="date" placeholder="添加日期起"></el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-date-picker v-model="queryInfo.queryEndDate" type="date" placeholder="添加日期止"></el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-input v-model="queryInfo.phoneNo" placeholder="请输入手机号"></el-input>
        </el-col>
        <el-col :span="4">
          <el-input v-model="queryInfo.name" placeholder="请输入客户姓名"></el-input>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" size="small" @click="getCardsList1">查&nbsp;&nbsp;询</el-button>
          <el-button type="primary" size="small" @click="addDialogVisible = true">添&nbsp;&nbsp;加</el-button>
          <el-button type="primary" size="small" @click="impDialogVisible = true">导&nbsp;&nbsp;入</el-button>
          <el-button type="primary" size="small" @click="downloadTmplate">模板下载</el-button>
        </el-col>
      </el-row>
      <!-- 查询列表 -->
      <el-table :data="cardlist" border stripe>
        <el-table-column type="index"></el-table-column>
        <el-table-column label="手机号码" prop="phoneNo"></el-table-column>
        <el-table-column label="客户姓名" prop="userName"></el-table-column>
        <el-table-column label="停车卡余额" prop="remainMoney"></el-table-column>
        <el-table-column label="停车卡面额" prop="amount"></el-table-column>
        <el-table-column label="有效期起">
          <template slot-scope="scope">{{ scope.row.beginTime | dateFormatYMD }}</template>
        </el-table-column>
        <el-table-column label="有效期止">
          <template slot-scope="scope">{{ scope.row.endTime | dateFormatYMD }}</template>
        </el-table-column>
        <el-table-column label="添加日期">
          <template slot-scope="scope">{{ scope.row.bindTime | dateFormat }}</template>
        </el-table-column>
      </el-table>
      <!-- 分页导航 -->
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 50]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>

    <!-- 添加停车卡弹出（单张） -->
    <el-dialog title="添加停车卡" :visible.sync="addDialogVisible" width="50%" @close="addDialogClose">
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="100px">
        <el-form-item label="手机号码" prop="phoneNo">
          <el-input v-model="addForm.phoneNo"></el-input>
        </el-form-item>
        <el-form-item label="客户姓名" prop="name">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item label="金额" prop="amount">
          <el-input v-model="addForm.amount" type="number"></el-input>
        </el-form-item>
        <el-form-item label="有效期起" prop="beginDate">
          <el-date-picker v-model="addForm.beginDate" type="date" style="width: 100%"></el-date-picker>
        </el-form-item>
        <el-form-item label="有效期止" prop="endDate">
          <el-date-picker v-model="addForm.endDate" type="date" style="width: 100%"></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addParkCard">添 加</el-button>
      </div>
    </el-dialog>
    <!-- 导入停车卡弹出 -->
    <el-dialog title="导入停车卡" :visible.sync="impDialogVisible" width="50%" @close="impialogClose">
      <el-form :model="impForm" ref="impFormRef" label-width="80px">
        <!-- <el-form-item label="金额" prop="amount">
          <el-input v-model="impForm.amount" type="number"></el-input>
        </el-form-item>
        <el-form-item label="有效期起" prop="beginDate">
          <el-date-picker v-model="impForm.beginDate" type="date" style="width: 100%"></el-date-picker>
        </el-form-item>
        <el-form-item label="有效期止" prop="endDate">
          <el-date-picker v-model="impForm.endDate" type="date" style="width: 100%"></el-date-picker>
        </el-form-item>-->
        <el-upload
          style="margin-top: 10px;"
          ref="uploadRef"
          action
          multiple
          :limit="1"
          :file-list="fileList"
          :auto-upload="false"
          :on-change="handleChange"
          :on-remove="handleRemove"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        >
          <el-button size="small" type="info">选择文件</el-button>
        </el-upload>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="impialogClose">取 消</el-button>
        <el-button type="primary" @click="impParkCard">保 存</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="impTitle" :visible.sync="dialogTableVisible">
      <el-table :data="alertData">
        <el-table-column property="rowNum" label="错误行号" width="150"></el-table-column>
        <el-table-column property="errMsg" label="错误原因"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogTableClose">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { dateFormat, getMonthEnd, getMonthStart } from '@/utils/utils'

export default {
  created () {
    this.initPage() // 进入页面初始化查询
  },

  data () {
    // 验证手机号的规则
    var checkMobile = (rule, value, cb) => {
      // 验证手机号的正则表达式
      const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/

      if (regMobile.test(value)) {
        return cb()
      }
      cb(new Error('请输入合法的手机号'))
    }
    // 数据绑定
    return {
      // 导入提示相关
      alertData: [],
      dialogTableVisible: false,
      impTitle: '导入失败',

      exceldata: null, // excel读取的数据
      token: '', // 页面暂存token
      addDialogVisible: false, // 单次添加停车卡的对话框显示与否
      impDialogVisible: false, // 导入添加停车卡的对话框显示与否
      merchantId: '', // 商户ID
      roadParks: '', // 路侧停车场权限
      thirdParks: '', // 三方车场权限
      cardlist: [], // 查询停车卡数据
      total: 0, // 查询数据总数
      fileTemp: null, // 导入的文件
      fileList: [],
      queryInfo: {
        // 查询条件
        queryStartDate: getMonthStart(),
        queryEndDate: getMonthEnd(),
        phoneNo: null,
        name: null,
        pagenum: 1,
        pagesize: 10
      },
      addForm: {
        // 单次添加数据
        phoneNo: '',
        name: '',
        amount: '',
        beginDate: '',
        endDate: ''
      },
      impForm: {
        // 导入添加数据
        // amount: '',
        // beginDate: '',
        // endDate: '',
        // phones: '',
        // names: '',
        impData: [] // 导入的数据格式
      },
      // 添加表单验证规则
      addFormRules: {
        phoneNo: [
          { required: true, message: '手机号码不能为空', trigger: 'blur' },
          { validator: checkMobile }
        ],
        // name: [
        //   { required: true, message: '客户姓名不能为空', trigger: 'blur' }
        // ],
        amount: [
          { required: true, message: '停车卡金额不能为空', trigger: 'blur' }
        ],
        beginDate: [
          { required: true, message: '有效期起不能为空', trigger: 'blur' }
        ],
        endDate: [
          { required: true, message: '有效期止不能为空', trigger: 'blur' }
        ]
      }
      // impFormRules: { // 导入表单验证规则
      //   amount: [
      //     { required: true, message: '停车卡金额不能为空', trigger: 'blur' }
      //   ],
      //   beginDate: [
      //     { required: true, message: '有效期起不能为空', trigger: 'blur' }
      //   ],
      //   endDate: [
      //     { required: true, message: '有效期止不能为空', trigger: 'blur' }
      //   ]
      // }
    }
  },

  methods: {
    // 页面初始化
    initPage () {
      const token = window.sessionStorage.getItem('token')
      if (undefined === token || token === '') {
        // 判断用户登录是否有效
        this.$message.error('您的登录已失效，请重新登录')
        window.sessionStorage.clear()
        this.$router.push('/login')
      }
      this.token = token
      // 获取merchantId
      const merchantId = window.sessionStorage.getItem('merchantId')
      if (undefined === merchantId || merchantId === '') {
        // 判断merchantId是否存在
        this.$message.error('您的登录已失效，请重新登录')
        window.sessionStorage.clear()
        this.$router.push('/login')
      }
      this.merchantId = merchantId
      // 获取路侧、停车场权限
      this.roadParks = window.sessionStorage.getItem('roadValidScope')
      this.thirdParks = window.sessionStorage.getItem('thirdValidScope')

      // 初始化查询
      this.getCardsList1()
    },

    // 查询按钮
    getCardsList1 () {
      this.queryInfo.pagenum = 1
      this.getCardsList()
    },

    // 查询商户停车卡列表（异步）
    getCardsList () {
      // 处理日期查询条件
      let startDateStr = null
      let endDateStr = null
      if (this.queryInfo.queryStartDate !== null) {
        startDateStr = dateFormat(this.queryInfo.queryStartDate) + ' 00:00:00'
      }
      if (this.queryInfo.queryEndDate !== null) {
        endDateStr = dateFormat(this.queryInfo.queryEndDate) + ' 23:59:59'
      }
      // 查询列表(异步查询)
      this.$http
        .get('queryMerchantCards', {
          headers: { token: this.token },
          params: {
            // 查询参数
            pagenum: this.queryInfo.pagenum,
            pagesize: this.queryInfo.pagesize,
            queryStartDate: startDateStr,
            queryEndDate: endDateStr,
            phoneNo: this.queryInfo.phoneNo,
            name: this.queryInfo.name,
            merchantId: this.merchantId
          }
        })
        .then(result => {
          const res = result.data
          this.cardlist = res.rows
          this.total = res.total
        })
    },

    // 添加停车卡
    addParkCard () {
      this.$refs.addFormRef.validate(async valid => {
        if (!valid) return false
        // 处理有效期日期
        const dateStartStr = dateFormat(this.addForm.beginDate) + ' 00:00:00'
        const dateEndStr = dateFormat(this.addForm.endDate) + ' 23:59:59'
        // 发起添加用户网络请求
        const { data: res } = await this.$http.get('addMerchantUserCard', {
          headers: { token: this.token },
          params: {
            merchantId: this.merchantId,
            phoneNo: this.addForm.phoneNo,
            amount: this.addForm.amount,
            beginDate: dateStartStr,
            endDate: dateEndStr,
            roadParks: this.roadParks,
            thirdParks: this.thirdParks,
            name: this.addForm.name
          }
        })
        if (res.code === '0') {
          this.$message.success('添加成功')
          this.getCardsList1()
          this.addDialogClose()
        } else {
          return this.$message.error(res.message)
        }
      })
    },

    // 添加停车卡批量
    async addParkCardBatch () {
      // this.$refs.impFormRef.validate(async valid => {
      //   if (!valid) return false
      //   // 处理有效期日期
      //   const dateStartStr = dateFormat(this.impForm.beginDate) + ' 00:00:00'
      //   const dateEndStr = dateFormat(this.impForm.endDate) + ' 23:59:59'
      //   // 发起添加用户网络请求
      //   const { data: res } = await this.$http.get('addMerchantUserCardBatch', {
      //     headers: { token: this.token },
      //     params: {
      //       merchantId: this.merchantId,
      //       phoneNos: this.impForm.phones,
      //       amount: this.impForm.amount,
      //       beginDate: dateStartStr,
      //       endDate: dateEndStr,
      //       roadParks: this.roadParks,
      //       thirdParks: this.thirdParks,
      //       names: this.impForm.names
      //     }
      //   })
      //   if (res.code === '0') {
      //     this.$message.success(res.message)
      //     this.getCardsList1()
      //     this.impialogClose()
      //   } else {
      //     return this.$message.error(res.message)
      //   }
      // })

      // console.log(this.impForm.impData)
      const { data: res } = await this.$http.post('addMerchantUserCardBatch',
        'merchantId=' + this.merchantId + '&roadParks=' + this.roadParks + '&thirdParks=' + this.thirdParks + '&jsonData=' + JSON.stringify(this.impForm.impData),
        { headers: { token: this.token } }
      )
      if (res.code === '0') {
        if (res.data.length > 0) {
          this.alertData = res.data
          this.impTitle = '以下用户导入失败'
          this.dialogTableVisible = true
        } else {
          this.$message.success(res.message)
          this.getCardsList1()
          this.impialogClose()
        }
      } else {
        return this.$message.error(res.message)
      }
    },

    // 添加弹出关闭
    addDialogClose () {
      this.$refs.addFormRef.resetFields()
      this.addDialogVisible = false
    },

    // 导入警告框关闭
    dialogTableClose () {
      this.alertData = []// 警告弹出框数据置空
      this.dialogTableVisible = false// 不显示
      this.impialogClose()// 关闭导入框
      this.getCardsList1()// 主页查询
    },

    // 导入对话框关闭
    impialogClose () {
      this.$refs.impFormRef.resetFields()
      this.$refs.uploadRef.clearFiles()
      this.fileList = []
      this.fileTemp = null
      this.impDialogVisible = false
    },

    // 导入文件变化函数
    handleChange (file, fileList) {
      this.fileTemp = file.raw
    },

    // 导入文件删除
    handleRemove (file, fileList) {
      this.fileTemp = null
    },

    // 保存导入
    impParkCard () {
      this.$refs.impFormRef.validate(async valid => {
        if (!valid) return false
      })
      if (this.fileTemp) {
        if (
          this.fileTemp.type ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
          this.fileTemp.type === 'application/vnd.ms-excel'
        ) {
          this.impExcel(this.fileTemp)
        } else {
          return this.$message.error('请选择excel类型文件')
        }
      } else {
        return this.$message.error('请选择需要导入的excel文件')
      }
    },

    // 验证手机号码
    checkPhoneNo (value) {
      // 验证手机号的正则表达式
      const regMobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
      return regMobile.test(value)
    },

    // 解析excel文件
    impExcel (obj) {
      var _this = this
      // 通过DOM取文件数据
      this.file = obj
      var rABS = false // 是否将文件读取为二进制字符串
      var f = this.file
      var reader = new FileReader()
      FileReader.prototype.readAsBinaryString = function (f) {
        var binary = ''
        var rABS = false // 是否将文件读取为二进制字符串
        var wb // 读取完成的数据
        var outdata
        var reader = new FileReader()
        reader.onload = function (e) {
          var bytes = new Uint8Array(reader.result)
          var length = bytes.byteLength
          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i])
          }
          var XLSX = require('xlsx')
          if (rABS) {
            // eslint-disable-next-line no-undef
            wb = XLSX.read(btoa(fixdata(binary)), {
              // 手动转化
              type: 'base64'
            })
          } else {
            wb = XLSX.read(binary, {
              type: 'binary'
            })
          }
          outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]) // outdata就是你想要的东西
          this.exceldata = [...outdata]
          _this.alertData = []// 清空表单数据
          _this.impForm.impData = []// 清空上传数据格式
          // 检查导入的数据格式
          this.exceldata.map((v, i) => {
            const rowNum = i + 2 // 行号
            let errmsg = ''// 错误信息
            if (undefined !== v.手机号码) {
              const phone = v.手机号码
              const je = v.金额
              const yxqq = v.有效期起
              const yxqz = v.有效期止
              let name = v.姓名
              let yxqqTmp = ''
              let yxqzTmp = ''
              if (undefined === name) {
                name = ''
              }
              // 验证手机号
              if (!_this.checkPhoneNo(phone)) {
                errmsg = errmsg + '手机号码格式错误；'
              }
              // 判断金额
              if (undefined === je) {
                errmsg = errmsg + '金额不能为空；'
              } else {
                if (isNaN(je)) {
                  errmsg = errmsg + '金额不是数字；'
                }
              }
              // 有效期起
              if (undefined === yxqq) {
                errmsg = errmsg + '有效期起不能为空；'
              } else {
                if (isNaN(yxqq)) {
                  errmsg = errmsg + '有效期起格式不正确；'
                } else {
                  yxqqTmp = _this.transDataDate(yxqq)
                  if (yxqqTmp === '' || yxqqTmp.indexOf('-') === -1) {
                    errmsg = errmsg + '有效期起格式不正确1；'
                  }
                }
              }
              // 有效期止
              if (undefined === yxqz) {
                errmsg = errmsg + '有效期止不能为空；'
              } else {
                if (isNaN(yxqz)) {
                  errmsg = errmsg + '有效期止不能为空；'
                } else {
                  yxqzTmp = _this.transDataDate(yxqz)
                  if (yxqzTmp === '' || yxqzTmp.indexOf('-') === -1) {
                    errmsg = errmsg + '有效期止格式不正确1；'
                  }
                }
              }
              // 错误提示不为空，拼装错误行数据及提示信息
              if (errmsg !== '') {
                _this.alertData.push({ rowNum: rowNum, errMsg: errmsg })
              }
              // 拼装需要保存的数据
              _this.impForm.impData.push({
                amount: je,
                beginDate: yxqqTmp + ' 00:00:00',
                endDate: yxqzTmp + ' 23:59:59',
                phone: phone,
                name: name,
                rowNum: rowNum
              })
            }
          })

          // 没有错误拼装数据
          if (_this.alertData.length !== 0) {
            _this.impTitle = '导入excel格式错误，请修改后再导入'
            _this.dialogTableVisible = true
          } else {
            // 批量保存数据
            // console.log(_this.impForm.impData)
            _this.addParkCardBatch()
          }
        }
        reader.readAsArrayBuffer(f)
      }
      if (rABS) {
        reader.readAsArrayBuffer(f)
      } else {
        reader.readAsBinaryString(f)
      }
    },

    // 监听pagesize改变
    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getCardsList()
    },

    // 当前页码改变
    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getCardsList()
    },

    // 导入模板下载
    downloadTmplate () {
      // 下载地址
      window.location.href = 'http://www.jxybkj.cn/api/merchant/downloadTmplate'
    },

    // 数字表示的日期，转成2020-06-28格式的日期
    transDataDate (val) {
      const time = new Date((val - 1) * 24 * 3600000 + 1)
      time.setYear(time.getFullYear() - 70)
      const year = time.getFullYear() + ''
      const month = time.getMonth() + 1 + ''
      const date = time.getDate() - 1 + ''
      if (val && val.length === 1) {
        return year + val + month + val + date
      }
      const dateTmp = year + '-' + (month < 10 ? '0' + month : month) + '-' + (date < 10 ? '0' + date : date)
      return dateTmp
    }

  },

  computed: {}
}
</script>

<style lang="less" scoped>
.el-col {
  margin: 7px 7px 7px 7px;
}
</style>
